import { createContext } from 'react';

export const ResourcesContext = createContext({ resources: {} });
